import { TableCell, TableRow } from '@mui/material'
import { Fragment } from 'react'

import { TableRowInformation } from './TableRow'

export type MobileTableRowProps = {
  row: TableRowInformation
  rowIndex: number
  tableHead: string[]
}
const MobileTableRow = ({ row, rowIndex, tableHead }: MobileTableRowProps) => (
  <TableRow
    key={rowIndex}
    hover={!!row.onClick}
    sx={row.onClick ? { cursor: 'pointer' } : undefined}
    onClick={row.onClick}
  >
    <TableCell scope="row" colSpan={tableHead.length}>
      {tableHead.map((cell, cellIndex) => {
        const value = row[cell]
        const cellContent = typeof value === 'function' ? '' : (value as React.ReactNode)

        return (
          <Fragment key={`${rowIndex}-${cellIndex}`}>
            <strong>{tableHead[cellIndex]}:</strong> {cellContent || ''}
            <br />
          </Fragment>
        )
      })}
    </TableCell>
  </TableRow>
)

export default MobileTableRow
